import React from 'react';
import PropTypes from 'prop-types';
import Autosuggest from 'react-autosuggest';

// Use your imagination to render suggestions.
export class InstructorSearch extends React.Component {
    static get props() {
        return {
            searchInstructorInfo: PropTypes.func.isRequired,
            changeInstructorData: PropTypes.func.isRequired,
            options: PropTypes.Object.isRequired
        };
    }
    constructor(props) {
        super(props);

        // Autosuggest is a controlled component.
        // This means that you need to provide an input value
        // and an onChange handler that updates this value (see below).
        // Suggestions also need to be provided to the Autosuggest,
        // and they are initially empty because the Autosuggest is closed.
        this.state = {
            value: '',
            suggestions: [],
            loading: false
        };
        this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
    }

    onSuggestionSelected(event, { suggestion }){
        if (suggestion.noResult){
            this.setState({
                value: '',
            });
        }
    }

    onChange = (event, { newValue }) => {
        this.setState({
            value: newValue
        });
    };

    renderSuggestion(suggestion) {
        if (suggestion.noResult){
            return (
                <div className="add-new-item-template">
                    <span>No results with that email. Add information? &nbsp; &nbsp;</span>
                    <svg aria-hidden="true"
                        focusable="false"
                        className="item-add-18" >
                        <use xlinkHref="#item-add-18"/>
                    </svg>
                </div>
            );
        }else{
            return (<div className='suggestion-item'>
                <span className='inst-email'>{suggestion.email}</span> | <span className='inst-name'>{suggestion.firstName} {suggestion.lastName} </span>
                <span className='inst-username'>{suggestion.id ? suggestion.username ? ' | ' + suggestion.username : '' : ' | No Account'} </span>
            </div>);
        }
    }
    // Autosuggest will call this function every time you need to update suggestions.
    // You already implemented this logic above, so just use it.
    onSuggestionsFetchRequested = ({ value }) => {
        /*this.setState({
            suggestions: getSuggestions(value)
        });*/
        const options = {
            searchTerm: value,
            geoId: this.props.options.geoId,
            unscrubbed: this.props.options.unscrubbed
        };
        //Fetch Data From API and show loading
        this.setState({loading: true});
        this.props.searchInstructorInfo("Instructor",options).then((response)=>{
            const insResData = response[0].data;
            const userResData = response[1].data;
            const resData = [].concat(insResData,userResData);
            this.setState({
                
                suggestions: (resData.length === 0) ? [{
                    noResult: true,
                    email: value ,
                    firstName: "Non-Profile",
                    lastName: ""
                }] : resData, loading: false
            });
        });
    };

    // Autosuggest will call this function every time you need to clear suggestions.
    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    getSuggestionSelectedValue = suggestion =>{
        console.log('Getting suggestion value');
        if(suggestion.noResult){
            const valueObj = {
                email: suggestion.email,
            };
            this.props.changeInstructorData(valueObj,'non-profile');
        }else{
            const valueObj = {
                email: suggestion.email,
                firstName: suggestion.firstName,
                lastName: suggestion.lastName,
                username: suggestion.username,
                telephone: suggestion.telephone? suggestion.telephone: '',
                saveInstructorObj: suggestion
            };
            this.props.changeInstructorData(valueObj,'all');
        }
        return suggestion.email;
    };

    render() {
        const { value, suggestions, loading } = this.state;
        // Autosuggest will pass through all these props to the input.
        const inputProps = {
            placeholder: 'Enter Instructor Email',
            value,
            onChange: this.onChange
        };

        // Finally, render it!
        return (
            <div>
                <h3>{loading? 'loading...' : 'Search Instructor'}</h3>
                <Autosuggest
                    suggestions={suggestions}
                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                    getSuggestionValue={this.getSuggestionSelectedValue}
                    onSuggestionSelected={this.onSuggestionSelected}
                    renderSuggestion={this.renderSuggestion}
                    inputProps={inputProps}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/OrderDetailsComponents/InstructorSearch.js